const visitPage = {
  en: {
    visits: {
      title: 'Visits',
      filterTitle: 'Filter',
      showClosedBtn: 'Show closed',
      error: 'Something went wrong',
      noMoreData: 'No more data',
      clearFiltersBtn: 'Clear filters',
      table: {
        dateHeader: 'Date',
        patientHeader: 'Patient & location',
        doctorHeader: 'Doctor',
        orderHeader: 'Ordered',
        typeHeader: 'Type',
        statusHeader: 'Status',
        ctaHeader: '',
        noDoctor: 'No doctor',
        tooltips: {
          followUp: 'Need a follow-up',
          lab: 'Lab ordered',
          xRay: 'X-Ray ordered',
        },
      },
      filters: {
        locations: 'Locations',
        patients: 'Patients',
        orders: 'Orders',
        familyInvolved: 'Family involved',
        status: 'Status',
        allBtn: 'All',
        showLessBtn: 'Show less',
        showAllBtn: 'Show all',
        showMoreBtn: 'Show more'
      },
      ordersTitle: {
        labOrder: 'Labs',
        imageOrder: 'Imaging',
        callToLocation: 'Call to locations',
        followUpVisit: 'Follow-up',
        callToFamily: 'Call to family',
      },
      schedule: 'Schedule visit',
    },
    schedule: {
      title: 'Schedule a visit',
    },
    visit: {
      title: 'Visit for {msg}',
      unassignedCommunity: 'Unassigned',
      empty: '',
      minus: '-',
      other: 'Other',
      printResultBtn: 'Print visit results',
      visitInfoCard: {
        title: 'Visit information',
        subtitle: 'If you want to invite someone to join the visit, you can share this link with them:',
        reopenRoomBtn: 'Reopen visit room',
        zoomId: 'Zoom ID',
      },
      visitTypes: {
        followUp: 'Follow-up call',
        urgentCare: 'Urgent care call',
      },
      completeForm: {
        titles: {
          summaryVisit: 'Summary of the visit*',
          sendToER: 'Sent to the ER?*',
          erElegible: 'ER (Emergency Room) eligible?*',
          instructionForLocation: 'Instructions for the location*',
          labOrdered: 'Labs ordered?*',
          imagesOrdered: 'Images (X-Ray) ordered?*',
          followUp: 'Follow-up visit needed?*',
          familyMembers: 'Family Members involved?',
          medicalDevices: 'Medical devices used:',
        },
        subtitles: {
          locationNotes: 'Notes:',
          labOrderedDetails: 'Lab order details:',
          imagesOrderedDetails: 'Imaging order details:',
          followUpType: 'Type of follow-up*',
          selectCadence: 'Select cadence of checking:*',
          followUpDescription: 'Description:*',
          followUpPrivateNote: 'Private note:',
        },
        placeholders: {
          location: 'What you are requesting the location to do for the patient.',
          summaryVisit: 'Please share any specific information that might be important',
          hours: 'Hours',
          minutes: 'Minutes',
          followUpDesc: 'Who to follow up with and what follow up is needed',
        },
        labels: {
          description: 'Description:*',
          privateNote: 'Private notes:',
        },
        radioBtnLabel: {
          yes: 'Yes',
          no: 'No',
          phoneUpdate: 'Phone update',
          videoVisit: 'Video visit',
          none: 'None of above',
        },
        validation: {
          required: 'Required',
          incorrectEmail: 'Incorrect email',
          incorrectPhone: 'Incorrect phone number',
          atLeast20characters: 'Please enter at least 20 characters',
          atLeast2characters: 'Please enter at least 2 characters',
        },
        familyMembers: {
          methods: {
            inRoom: 'In-person',
            phoneCall: 'Phone',
            video: 'Video',
          },
        },
        createContactDialog: {
          title: 'Create contact',
          labels: {
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            mobilePhone: 'Mobile phone',
            homePhone: 'Home phone',
            workPhone: 'Work phone',
            faxPhone: 'Fax phone',
            relationship: 'Relationship to patient',
            relationshipDesc: 'Relationship description',
            addPhoneNumber: 'Add mobile phone',
          },
          placeholders: {
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            mobilePhone: 'Mobile phone',
            homePhone: 'Home phone',
            workPhone: 'Work phone',
            faxPhone: 'Fax phone',
            relationship: 'Specify relationship',
            relationshipDesc: 'Description on the type (Wife, Doctor)',
          },
          createBtn: 'Create contact',
        },
        familyMemberDialog: {
          title: 'Add family member',
          subtitle: 'Select contact member',
          addContactBtn: 'Add new contact',
          selectContactPlaceholder: 'Select contact member',
          addFamilyMemberBtn: 'Add family member',
        },
        addFamilyMemberBtn: 'Add family members',
        updateBtn: 'Update',
        completeBtn: 'Complete',
        cancelBtn: 'Cancel',
      },
      visitStatusOpt: {
        requestedTitle: 'Click "Mark as acknowledged" to confirm you received the visit request.',
        requestedBtn: 'Mark as acknowledged',
        reviewingTitle: 'Click “Start visit” to open the video conference room.',
        reviewingBtn: 'Start visit',
        startedTitle: 'The video conference is in the progress. If the call has ended, click on “End call”.',
        startedBtn: 'End call',
        callEndedTitle: 'Call has ended. Write the closing notes and save.',
        callEndedBtn: 'Complete',
        pendingTasksTitle:
          'Call has ended but there are pending tasks which need to be resolved. Once done, the visit status will automatically change to “Completed”.',
        completedTitle: 'Call is fully completed. You can view summary notes if needed.',
        reopenVisitRoom: 'Reopen visit room',
      },
      additionalInfo: {
        reasonTitle: 'Reason for a visit',
        additionalInfoTitle: 'Additional information',
        otherReason: 'Other',
      },
      tabs: {
        participantTab: {
          title: 'Participants',
          patientTitle: 'Patient',
          matchPatientBtn: 'Match the patient',
          updatePatientBtn: 'Update patient',
          addConsentTitle: 'Add consent',
          viewMediacalDataBtn: 'View medical data',
          dateOfBirth: 'Date of birth:',
          location: 'Location',
          athenaId: 'Athena (EMR) ID',
          phone: 'Phone number',
          consent: 'Consent',
          methods: 'Methods:',
          noConsent: 'No consent',
          roles: {
            patient: 'Patient',
            clinician: 'Clinician',
            initiator: 'Initiator',
          },
          invitations: {
            byEmailAndPhone: 'Invited',
            byPhone: 'Invited via phone',
            byEmail: 'Invited via email',
            unknownContact: 'Unknown contact',
          },
          inviteBtn: 'Invite contact to the call',
        },
        auditTrailTab: {
          osAndBrowser: 'OS and Browser',
        },
        visitSummaryTab: {
          noMedicalDevices: 'Medical devices were not used',
          booleanFormats: {
            yes: 'Yes',
            no: 'No',
          },
          titles: {
            reasonForVisit: 'Reason for a visit',
            additionalInfo: 'Additional information',
            familyMembers: 'Family member involved?',
            er: 'Emergency room',
            erEligible: 'ER eligible',
            location: 'Location instructions',
            followUp: 'Follow-up visit needed?',
            ordered: 'Ordered assets',
            images: 'Images (X-Ray)',
            labs: 'Labs ordered?',
            summary: 'Summary of the visit',
            medicalDevices: 'Medical devices used',
            temboNotes: 'Private internal Tembo notes',
          },
          viewBtn: 'View',
        },
        tasksTab: {
          titles: {
            images: 'Images (X-Ray) reminder',
            labs: 'Labs ordered reminder',
            callToLocation: 'Call To location reminder',
            followUp: 'Follow-up reminder',
            callToFamily: 'Call to family reminder',
          },
          optionsTitles: {
            resolve: 'Resolve',
            unableToConnect: 'Unable to connect',
            canceled: 'Canceled',
            ordered: 'Ordered',
            scheduled: 'Mark as scheduled',
            collected: 'Mark as collected',
          },
          snoozeStatus: {
            resolved: 'Resolved',
            unableToConnect: 'Unable to Connect',
            canceled: 'Canceled',
            ordered: 'Ordered',
            scheduled: 'Scheduled',
            connected: 'Connected no Resolution',
            collected: 'Collected',
            noStatus: 'No status',
          },
          form: {
            date: 'Due date',
            lastUpdate: 'Last updated',
            createdAt: 'Created at',
            changeStatus: 'Change status to:',
            selectStatusPlaceholder: 'Select Status',
            applyBtn: 'Apply',
            results: 'Results',
            linkToVisit: 'Link to completed visit',
            snoozed: 'Was snoozed',
          },
          hideBtn: 'Hide details',
          showBtn: 'Show details',
        },
      },
      completeTask: {
        connectionType: {
          email: 'Email',
          phone: 'Phone',
          fax: 'Fax',
        },
        validation: {
          min20: 'Please enter at least 20 characters',
          min10: 'Result must be longer than or equal to 10 characters',
          required: 'Required',
        },
        notifications: {
          providePerson: 'Please, provide who performed the call',
        },
        cancel: {
          title: 'Cancelling of {msg} task',
          reason: 'Reason of cancelling:',
          reasonPlaceholder: 'Provide reason of cancelling',
          results: {
            lab: 'Lab',
            images: 'Images (X-ray)',
            callToLocation: 'Call to location',
            callToFamily: 'Call to family',
            followUp: 'Follow-up',
          },
        },
        complete: {
          followUpTitle: 'Complete follow-up',
          taskTitle: 'Complete task {msg}',
          results: {
            lab: 'Lab',
            images: 'Images (X-ray)',
            callToLocation: 'Call to location',
            callToFamily: 'Call to family',
            followUp: 'Follow-up',
          },
        },
        followUp: {
          types: {
            followUp: 'Follow-up',
            urgentCare: 'Urgent care',
          },
        },
        default: {
          results: {
            lab: 'Lab results',
            images: 'Images (X-ray) results',
            callToLocation: 'Call to location results',
            callToFamily: 'Call to family results',
            followUp: 'Follow-up results',
          },
          titles: {
            notifyLocation: 'You need to notify location or family members',
            contactedLocation: 'Have you contacted location?',
            locationPerson: 'Provide name of the person with whom you have talked',
            method: 'Method',
            contactedFamilyMember: 'Have you contacted family members?',
            selectContact: 'Select contact member',
            followUp: 'Follow-up visit needed?',
            followUpType: 'Type of follow-up*',
            callToLocation: 'Call to location',
            followUpVisit: 'Follow-up visit',
            cadance: 'Select cadence of checking:*',
            description: 'Description:',
            privateNote: 'Private note:',
          },
          placeholders: {
            result: 'The blood sample results are normal and has no deviations',
            hours: 'Hours',
            minutes: 'Minutes',
            description: 'Who to follow up with and what follow up is needed',
            privateNote: 'Please share any specific information that might be important',
          },
          addNewContactBtn: 'Add new contact',
        },
        call: {
          familyMemberTitle: 'Family member contacted:*',
          staffMemberTitle: 'Staff member contacted:*',
          familyMemberPlaceholder: 'Please share the first and last name of the family member',
          staffMemberPlaceholder: 'Please share the first and last name of the contact',
          form: {
            titles: {
              summary: 'Summary of communication:*',
              method: 'Method',
              followUp: 'Follow-up visit needed?',
              followUpType: 'Type of follow-up',
              phone: 'Phone update',
              video: 'Video visit',
              cadence: 'Select cadence of checking:*',
              description: 'Description:*',
              privateNote: 'Private note:',
            },
            placeholders: {
              summary: 'Please give a brief overview of what was communicated',
              method: 'Method',
              hours: 'Hours',
              minutes: 'Minutes',
              description: 'Who to follow up with and what follow up is needed',
              privateNote: 'Please share any specific information that might be important',
            },
            updateBtn: 'Update',
          },
        },
      },
      deleteFilePopup: {
        title: 'Delete file',
        text: 'This action will delete the file. Are you sure you want to delete the file?',
        cancelButton: 'Cancel',
        confirmButton: 'Delete',
      },
      inviteToCallPopup: {
        inviteTitle: 'Invite contact',
        inviteToCallTitle: 'Invite contact to call',
        noContacts: 'The patient doesn’t have any contacts',
        cantBeInvited: "Can't be invited (add email or mobile phone)",
        addInfo: 'Add info',
        invited: 'Invited',
        sendBtn: 'Send',
        inviteBtn: 'Invite new contact',
        createAndInviteBtn: 'Create and invite',
        form: {
          firstName: 'First name',
          lastName: 'Last name',
          email: 'Email',
          relationship: 'Relationship to patient',
          relationshipDesc: 'Description of the type (Wife, Doctor)',
        },
      },
      copyMeetingLink: {
        default: 'Copy meeting link',
        zoom: 'Copy Zoom link',
      },
      notifications: {
        errorMsg: 'Something went wrong',
        statusUpdatedMsg: 'Visit status was updated',
        familyMemberAddedMsg: 'Family member has been successfully added',
        visitEditedMsg: 'The visit was edited',
        visitCompletedMsg: 'The visit was completed',
        noTaskMsg: 'Task not found',
        noPatientMsg: 'No patient found',
        noContactMsg: 'Contact was not invited. Please, try again',
        noInvitedContactMsg: 'Contact was not invited. Please, update contact email and try again',
        contactInvitedMsg: 'Contact {msg} was invited to call',
        visitFileAddedMsg: 'Visit file has been successfully added',
        visitFileDeletedMsg: 'Visit file has been successfully deleted',
        patientUpdatedMsg: 'Patient has been successfully updated',
        resolveErrorsMsg: 'Resolve any errors to save',
        contactCreatedMsg: 'Contact has been successfully created',
        patientVerificationRequired: 'You must match and verify the patient before ending the call'
      },
      reminders: {
        familyMemberDesc: 'Update family members',
      },
      messagePopupTitle: 'Please read the message before continue',
    },
    manageFiles: {
      title: 'Manage visit files for {msg}',
      removeBtn: 'Remove',
      updateBtn: 'Update',
      noFiles: 'No files attached',
      fileDeletedMsg: 'Visit file(s) has been successfully deleted',
      followUp: 'Follow-up call',
      urgentCare: 'Urgent care call',
      updateFilePopup: {
        title: 'Update file',
        text: 'This action will remove files. Are you sure you want to remove the files?',
        cancelButton: 'Cancel',
        confirmButton: 'Update',
      },
      error: 'Something went wrong',
    },
    addFiles: {
      title: 'Add visit files for {msg}',
      selectType: 'Select type',
      filesList: 'Files:',
      removeBtn: 'Remove',
      updateBtn: 'Update',
      imageResult: 'Imaging result',
      labResult: 'Lab result',
      otherResult: 'Other',
      addFiles: 'Add file(s)',
      fileFormatMsg: 'File(s) should be in pdf, png, or jpeg format',
      fileAddedMsg: 'Visit file(s) has been successfully added',
      followUp: 'Follow-up call',
      urgentCare: 'Urgent care call',
      error: 'Something went wrong',
    },
    previewFile: {
      title: 'Visit file',
      downloadBtn: 'Download',
      printBtn: 'Print document',
      error: 'Something went wrong',
    },
  },
}
export default visitPage
